import { grey } from '@mui/material/colors';

const CONTRACT_TEXT = process.env.REACT_APP_CONTRAST_TEXT_LIGHT || '#ffffff';

const themeConfig = {
  // Información básica de la marca
  title: process.env.REACT_APP_TITLE || '',
  logoUrl: process.env.REACT_APP_LOGO_URL || '/logo.svg',
  faviconUrl: process.env.REACT_APP_FAVICON_URL || '/favicon.ico',

  // Colores del tema
  theme: {
    error: {
      main: process.env.REACT_APP_ERROR_MAIN || '#F84842',
      contrastText: CONTRACT_TEXT,
    },
    success: {
      main: process.env.REACT_APP_SUCCESS_MAIN || '#72B62F',
      light: process.env.REACT_APP_SUCCESS_LIGHT || '#E0F2DA',
      contrastText: CONTRACT_TEXT,
    },
    primary: {
      main: process.env.REACT_APP_PRIMARY_MAIN || '#72B62F',
      light: process.env.REACT_APP_PRIMARY_LIGHT || '#C9DDBA',
      contrastText: CONTRACT_TEXT,
    },
    secondary: {
      ...grey,
      100: '#EDEEF0',
      200: '#E9E9E9',
      main: grey['900'],
      light: grey['400'],
    },
    info: {
      main: process.env.REACT_APP_INFO_MAIN || '#37AEFF',
      light: process.env.REACT_APP_INFO_LIGHT || '#2196f3',
      contrastText: CONTRACT_TEXT,
    },
    warning: {
      main: process.env.REACT_APP_WARNING_MAIN || '#FDA20A',
      light: process.env.REACT_APP_WARNING_LIGHT || '#FDA20A',
      contrastText: CONTRACT_TEXT,
    },
    background: {
      default: process.env.REACT_APP_BACKGROUND_DEFAULT || '#F3F5F7',
      paper: process.env.REACT_APP_BACKGROUND_PAPER || '#fff',
    },
    opacity: {
      main: process.env.REACT_APP_OPACITY_MAIN || '#fdfdfd59',
      contrastText: CONTRACT_TEXT,
    },
    neutral: {
      main: process.env.REACT_APP_NEUTRAL_MAIN || '#F4F5F6',
      contrastText: CONTRACT_TEXT,
    },
    formLabel: process.env.REACT_APP_FORM_LABEL || '#000000de',
    spaceSelector: process.env.REACT_APP_SPACE_SELECTOR || '#f3f4f9',
  },
};

export default themeConfig;
